
import { useNavigationMonitor } from '@/utils/navigationMonitor'; // We keep the same import path for backward compatibility
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';

/**
 * Component that tracks navigation events throughout the application
 * This is a "monitoring" component that doesn't render anything visible
 */
const NavigationMonitor = () => {
  // Use the navigation monitor hook
  const { lastNavigation } = useNavigationMonitor();
  const location = useLocation();
  
  // Add enhanced navigation monitoring
  useEffect(() => {
    console.log('Page changed to:', location.pathname);
    
    // Reset scroll position on navigation
    window.scrollTo(0, 0);
    
    // Add a listener to handle beforeunload events to clean up any pending states
    const handleBeforeUnload = () => {
      // Clean up any loading indicators or pending operations
      if (window._loadingIndicator) {
        window._loadingIndicator.endAllRequests();
      }
      
      // End any navigation tracking
      if (window.endNavigation) {
        window.endNavigation();
      }
    };
    
    // Handle network status changes
    const handleOnline = () => {
      toast.success("You're back online. App functionality restored.");
    };
    
    const handleOffline = () => {
      toast.error("You're offline. Some features may be limited.");
      
      // End any loading indicators
      if (window._loadingIndicator) {
        window._loadingIndicator.endAllRequests();
      }
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    
    // Set up performance mark for this navigation
    if (performance && performance.mark) {
      performance.mark(`navigation-to-${location.pathname}`);
    }
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [location.pathname]);
  
  // This component doesn't render anything
  return null;
};

export default NavigationMonitor;
